module.exports = __webpack_public_path__ + "static/img/01.6af9c50f.png";